'use client'

import { Charts } from './Charts';
import BPCChartsDataProvider from './contexts/BPCChartsDataContext';
const BPCWrapper = () => {
    return (
        <BPCChartsDataProvider>
            <Charts />
        </BPCChartsDataProvider>
    );
};

export default BPCWrapper;
